<template>
  <div class="p-6">
    <h2 class="text-xl font-semibold mb-4">Gestión de Usuarios</h2>

    <div class="dis-div">
      <v-row justify="end">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          hide-details
          label="Buscar Usuario"
          single-line
          class="r-search"
        />
      </v-row>
    </div>

    <!-- Tabla -->
    <v-data-table
      :headers="headers"
      :items="users"
      :search="search"
      :loading="loading"
      loading-text="Cargando Usuarios..."
      class="elevation-1 mt-5"
    >
      <template v-slot:[`item.role`]="{ item }">
        <v-chip v-for="r in item.role" :key="r" color="gray" small class="ma-1">
          {{ r }}
        </v-chip>
      </template>
      <template v-slot:[`item.permissions`]="{ item }">
        <v-dialog max-width="1000" transition="dialog-bottom-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="rgb(204 33 40)"
              class="white--text border-button mr-2"
              style="cursor: pointer"
              v-bind="attrs"
              v-on="on"
            >
              Ver Permisos
              <v-icon class="ml-2">mdi mdi-server-security</v-icon>
            </v-btn>
          </template>
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                dark
                style="
                  background-color: rgb(204 33 40);
                  color: white !important;
                "
              >
                Permisos Asociados Al Usuario [{{
                  item.name
                }}]

                <v-icon
                  style="margin-left: auto !important"
                  @click="dialog.value = false"
                  >mdi-close
                </v-icon>
              </v-toolbar>

              <div class="permiso-cell">
                <v-chip
                  v-for="r in item.permissions"
                  :key="r"
                  :color="getRandomColor(r)"
                  medium
                  class="ma-1"
                >
                  {{ r }}
                </v-chip>
              </div>
            </v-card>
          </template>
        </v-dialog>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          color="rgb(204 33 40)"
          class="white--text border-button"
          @click="editUser(item)"
        >
          Gestionar
          <v-icon class="ml-2">mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- Modal Crear Rol -->
    <v-dialog v-model="showModal" max-width="900px" persistent>
      <v-card>
        <v-card-title class="headline">
          Editar Usuario {{ this.form.name }}
          <v-spacer></v-spacer>
          <v-btn icon @click="showModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="form.email"
            label="Email del Usuario"
            disabled
          />
          <v-text-field v-model="form.company" label="Compañia" disabled />
          <v-row justify="center">
            <v-col cols="12" sm="6">
              <v-alert
                v-if="showAlert"
                :type="alertType"
                dense
                outlined
                border="left"
                colored-border
                class="my-4"
              >
                {{ alertMessage }}
              </v-alert>
            </v-col>
          </v-row>

          <div class="dis-div mt-3">
            <v-row justify="start" class="ml-1">
              <p class="c-black">Roles Disponibles</p>
            </v-row>
            <v-row justify="end" class="mr-1">
              <v-text-field
                v-model="searchModalRole"
                append-icon="mdi-magnify"
                hide-details
                label="Buscar Rol"
                single-line
                class="r-search"
              />
            </v-row>
          </div>

          <v-row class="rol-lista mt-3" justify="start">
            <v-col
              v-for="p in filteredRoles"
              :key="p.name"
              cols="12"
              sm="6"
              md="6"
            >
              <v-card class="permiso-card" elevation="3">
                <v-card-text class="d-flex align-center bcard">
                  <v-checkbox
                    v-model="selectedRoles"
                    :value="p.name"
                    hide-details
                    class=""
                    style="margin-top: inherit"
                    color="rgb(204 33 40)"
                  ></v-checkbox>
                  <div class="div-b-c">
                    <span>{{ p.name }}</span>
                    <p class="tam-p">{{ p.description }}</p>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <div 
            class="dis-div mt-3" 
            v-if="Array.isArray(removePermissionsSelectRole) && removePermissionsSelectRole.length > 0"
          >
            <v-row justify="start" class="ml-1">
              <p class="c-black">Permisos Disponibles</p>
            </v-row>
            <v-row justify="end" class="mr-1">
              <v-text-field
                v-model="searchModal"
                append-icon="mdi-magnify"
                hide-details
                label="Buscar Permiso"
                single-line
                class="r-search"
              />
            </v-row>
          </div>

          <v-row class="permiso-lista mt-3" justify="start">
            <v-col
              v-for="p in removePermissionsSelectRole"
              :key="p.name"
              cols="12"
              sm="6"
              md="6"
            >
              <v-card class="permiso-card" elevation="3">
                <v-card-text class="d-flex align-center bcard">
                  <v-checkbox
                    v-model="selectedPermissions"
                    :value="p.name"
                    hide-details
                    class=""
                    style="margin-top: inherit"
                    color="rgb(204 33 40)"
                  ></v-checkbox>
                  <div class="div-b-c">
                    <span>{{ p.name }}</span>
                    <p class="tam-p">{{ p.description }}</p>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray" text @click="closeModal">Cancelar</v-btn>
          <v-btn
            style="background-color: rgb(204 33 40); color: white !important"
            @click="saveUser"
          >
            Guardar Cambios
          </v-btn>
        </v-card-actions>
        <v-overlay :value="loading" absolute opacity="0.6">
          <v-progress-circular
            indeterminate
            size="64"
            color="rgb(204 33 40)"
          ></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { environment } from "@/data/environment";
export default {
  name: "UserRolesPermissions",
  data() {
    return {
      search: "",
      searchModal: "",
      searchModalRole: "",
      headers: [
        { text: "ID", value: "id" },
        { text: "Nombre del Usuario", value: "name" },
        { text: "Email", value: "email" },
        { text: "Compañía", value: "company" },
        { text: "Rol", value: "role" },
        { text: "Permisos", value: "permissions" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      users: [],
      availableRoles: [],
      availablePermissions: [],
      selectedPermissions: [],
      selectedRoles: [],
      showModal: false,
      formValid: false,
      form: {
        id: null,
        name: "",
        email: "",
        company: "",
      },
      showAlert: false,
      alertMessage: "",
      alertType: "success",
      loading: false,
    };
  },
  mounted() {
    this.fetchUsers();
    this.fetchPermissions();
    this.fetchRoles();
  },
  computed: {
    filteredPermissions() {
      if (!this.searchModal) return this.availablePermissions;
      const term = this.searchModal.toLowerCase();
      return this.availablePermissions.filter(
        (p) =>
          p.name.toLowerCase().includes(term) ||
          p.description.toLowerCase().includes(term)
      );
    },
    filteredRoles() {
      if (!this.searchModalRole) return this.availableRoles;
      const term = this.searchModalRole.toLowerCase();
      return this.availableRoles.filter(
        (r) =>
          r.name.toLowerCase().includes(term) ||
          r.description.toLowerCase().includes(term)
      );
    },
    //Seleccion de roles para remover los permisos de este del listado de permisos
    removePermissionsSelectRole() {
      if (!this.selectedRoles || this.selectedRoles.length === 0) {
        return this.availablePermissions;
      }

      // Buscar los roles seleccionados como objetos completos
      const selectedRoleObjects = this.availableRoles.filter((role) =>
        this.selectedRoles.includes(role.name)
      );

      // Obtener todos los permisos de esos roles
      const permissionsToRemove = selectedRoleObjects.flatMap((role) =>
        role.permissions.map((p) => p.name)
      );

      // Filtrar los permisos disponibles para eliminar los del rol
      return this.availablePermissions.filter(
        (perm) => !permissionsToRemove.includes(perm.name)
      );
    },
  },
  methods: {
    async fetchUsers() {
      try {
        this.loading = true;
        const response = await axios.get(
          environment.HIOPOSWEBSERVICESCOMBINED + "/api/getUserWithRolAndPermission/2"
        );

        this.users = response.data.data;
      } catch (error) {
        console.error("Error al obtener usuarios:", error);
      } finally {
        this.loading = false;
      }
    },
    async fetchRoles() {
      try {
        const response = await axios.get(
          environment.HIOPOSWEBSERVICESCOMBINED + "/api/getRoles/2"
        );
        this.availableRoles = response.data.data;
      } catch (error) {
        console.error("Error al obtener roles:", error);
      }
    },
    async fetchPermissions() {
      try {
        const response = await axios.get(
          environment.HIOPOSWEBSERVICESCOMBINED + "/api/getPermissions/2"
        );

        this.availablePermissions = response.data.data;
      } catch (error) {
        console.error("Error al obtener permisos:", error);
      }
    },
    editUser(item) {
      this.showModal = true;
      this.form = {
        id: item.id,
        name: item.name,
        email: item.email,
        company: item.company,
      };
      this.selectedRoles = [...item.role];
      this.selectedPermissions = [...item.permissions];
    },
    async saveUser() {
      console.log("Usuario actualizado:", this.form);
      console.log("Roles:", this.selectedRoles);
      console.log("Permisos:", this.selectedPermissions);
      try {
        this.loading = true;
        let users = {
          id: this.form.id,
          role: this.selectedRoles,
          permissions: this.selectedPermissions,
        };
        const response = await axios.post(
          `${environment.HIOPOSWEBSERVICESCOMBINED}/api/editUser`,
          {
            user: users,
            country: 2,
          }
        );
        if (response.data.error) {
          this.setAlert("error", response.data.message);
        } else {
          this.closeModal();
          this.fetchUsers();
          this.fetchPermissions();
          this.fetchRoles();
        }
      } catch (error) {
        console.error("Error guardando permiso:", error);
        this.setAlert("error", "Error al guardar el permiso.");
      } finally {
        this.loading = false;
      }
    },
    closeModal() {
      this.showModal = false;
      this.form = { id: null, name: "", email: "", company: "" };
      this.selectedPermissions = [];
      this.selectedRoles = [];
    },
    getRandomColor(r) {
      const colors = ["gray"];
      const index = Math.abs(this.hashString(r)) % colors.length;
      return colors[index];
    },
    hashString(str) {
      return str.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
    },
    setAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
      setTimeout(() => (this.showAlert = false), 4000);
    },
  },
};
</script>


<style scoped>
.r-search {
  max-width: 50%;
  margin-right: 1%;
}
.dis-div {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
}
.div-b-c {
  display: block !important;
  align-items: center;
}
.c-black {
  font-size: x-large;
}
.permiso-lista {
  max-height: 350px; /* visible ~2 filas completas */
  overflow-y: auto;
  padding-right: 10px;
}

/* Scroll estilizado (opcional) */
.permiso-lista::-webkit-scrollbar {
  width: 6px;
}
.permiso-lista::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

/* Cards con mejor presentación */
.permiso-card {
  border-radius: 12px;
  transition: transform 0.2s ease;
}
.permiso-card:hover {
  transform: scale(1.03);
}
.tam-p {
  font-size: smaller;
}
.bcard {
  border: 1px solid rgb(8, 8, 8);
}
.border-button {
  border-radius: 15px;
}

.rol-lista {
  max-height: 150px;
  overflow-y: auto;
  padding-right: 10px;
}

/* Scroll estilizado (opcional) */
.rol-lista::-webkit-scrollbar {
  width: 6px;
}
.rol-lista::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.permiso-cell {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  padding: 20px;
  max-height: 400px; /* Ajusta según el alto que quieras mostrar */
  overflow-y: auto; /* Scroll vertical si hay muchos permisos */
  overflow-x: hidden;
  border-radius: 6px;
}

/* Scrollbar personalizado */
.permiso-cell::-webkit-scrollbar {
  width: 6px;
}

.permiso-cell::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}
</style>
